/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid4 from 'uuid4';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  startRequest as requestLoading,
  requestSuccess as successLoading,
  requestError as errorLoading,
} from '~/redux/ducks/loading';
import { Creators as ToastrMessageActions } from '~/redux/ducks/toastrMessage';

import Upload from '~/Components/Upload';
import Image from '~/Components/Image';
import Button from '~/Components/Button';

import UploadService, { baseUrlMedia } from '~/services/UploadService';

import LandingPage from '../../Components/LandingPage';

import {
  FormGroup,
  Input,
  Row,
  Imagem,
  BannerEmpty,
  ErrorMessage,
} from './styles';

class SMSMediaMessageForm extends Component {
  state = {
    showMessageErrorMaxSizeFileIcon: false,
    showMessageErrorMaxSizeFileImage: false,
  };

  getTitleIsInvalid = () => {
    const { criativoEdit } = this.props;
    const { content } = criativoEdit;

    if (content.channelData) {
      if (content.channelData.title) {
        return false;
      }
    }
    return true;
  };

  getSubtitleIsInvalid = () => {
    const { criativoEdit } = this.props;
    const { content } = criativoEdit;

    if (content.channelData) {
      if (content.channelData.subtitle) {
        return false;
      }
    }
    return true;
  };

  getButtonUrl1IsInvalid = () => {
    const { criativoEdit } = this.props;
    const { content } = criativoEdit;

    if (content.channelData) {
      if (
        content.channelData.button_url_1
        && content.channelData.button_url_1.match(
          /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
        )
      ) {
        return false;
      }
    }
    return true;
  };

  uploadFileToAWS = async (campaignUuid, file) => {
    const {
      startRequest,
      requestSuccess,
      requestError,
      errorMessage,
    } = this.props;

    startRequest();
    const filename = file.name;

    const extFile = filename.substr(
      filename.lastIndexOf('.') + 1,
      filename.length,
    );

    const randomFilename = uuid4();
    const photoKey = `campaigns/${campaignUuid}/${randomFilename}.${extFile}`;
    try {
      await UploadService.upload(photoKey, file);
      const urlMedia = `${baseUrlMedia}/campaigns/${campaignUuid}/${randomFilename}.${extFile}`;
      requestSuccess();
      return {
        url: urlMedia,
        file,
        extFile,
      };
    } catch (e) {
      errorMessage(
        'Atenção!',
        'Houve um problema ao enviar a mídia. Tente novamente mais tarde!',
      );
      requestError();
    }
    return null;
  };

  handleSuccessIcon = (icon) => {
    const {
      campaignEditCriativoRequestSuccess,
      criativoEdit,
    } = this.props;
    const { content } = criativoEdit;

    campaignEditCriativoRequestSuccess({
      ...criativoEdit,
      content: {
        ...content,
        channelData: {
          ...content.channelData,
          icon,
        },
      },
    });
  };

  handleSuccessImage = (image) => {
    const {
      campaignEditCriativoRequestSuccess,
      criativoEdit,
    } = this.props;
    const { content } = criativoEdit;

    let subtitleValidate = content.channelData ? content.channelData.subtitle : null;
    if (image && subtitleValidate) {
      if (subtitleValidate.length > 37) {
        subtitleValidate = subtitleValidate.substr(0, 37);
      }
    }

    campaignEditCriativoRequestSuccess({
      ...criativoEdit,
      content: {
        ...content,
        channelData: {
          ...content.channelData,
          subtitle: subtitleValidate,
          image,
        },
      },
    });
  };

  uploadFileIcon = async (files) => {
    const { campaign } = this.props;
    const file = files[0];
    if (file) {
      const { url } = await this.uploadFileToAWS(campaign.uuid, file);
      this.handleSuccessIcon(url);
    }
  };

  uploadFileImage = async (files) => {
    const { campaign } = this.props;
    const file = files[0];
    if (file) {
      const { url } = await this.uploadFileToAWS(campaign.uuid, file);
      this.handleSuccessImage(url);
    }
  };

  render() {
    const {
      criativoEdit,
      campaignEditCriativoRequestSuccess,
      hasError,
      campaign,
      disabledFields,
    } = this.props;
    const {
      showMessageErrorMaxSizeFileIcon,
      showMessageErrorMaxSizeFileImage,
    } = this.state;

    const { content } = criativoEdit;

    const maxLengthSubtitle = content && content.channelData && content.channelData.image ? 37 : 230;

    return (
      <>
        <Row>
          <FormGroup style={{ flex: 1 }}>
            <label>
              Título
              <span>*</span>
              -
              <small>
                {` ${
                  content.channelData && content.channelData.title
                    ? content.channelData.title.length : 0}/37 caracteres`}
              </small>
            </label>
            <Input
              disabled={disabledFields}
              placeholder="Digite o título"
              maxLength={37}
              onChange={(e) => {
                campaignEditCriativoRequestSuccess({
                  ...criativoEdit,
                  content: {
                    ...criativoEdit.content,
                    channelData: {
                      ...criativoEdit.content.channelData,
                      title: e.target.value,
                    },
                  },
                });
              }}
              value={content.channelData ? content.channelData.title || '' : ''}
              invalid={hasError && this.getTitleIsInvalid()}
            />
          </FormGroup>
        </Row>
        <Row>
          <FormGroup style={{ flex: 1 }}>
            <label>
              Subtítulo
              <span>*</span>
              -
              <small>
                {` ${
                  content.channelData && content.channelData.subtitle
                    ? content.channelData.subtitle.length : 0}/${maxLengthSubtitle} caracteres`}
              </small>
            </label>
            <Input
              disabled={disabledFields}
              placeholder="Subtítulo"
              maxLength={maxLengthSubtitle}
              onChange={(e) => {
                campaignEditCriativoRequestSuccess({
                  ...criativoEdit,
                  content: {
                    ...criativoEdit.content,
                    channelData: {
                      ...criativoEdit.content.channelData,
                      subtitle: e.target.value,
                    },
                  },
                });
              }}
              value={content.channelData ? content.channelData.subtitle || '' : ''}
              invalid={hasError && this.getSubtitleIsInvalid()}
            />
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <label>
              Ícone
            </label>
            <Row>
              <Imagem invalid={false /* hasError && this.getIconIsInvalid() */}>
                {content.channelData && content.channelData.icon ? (
                  <Image
                    className="success-img"
                    src={content.channelData.icon}
                    alt="imagem"
                  />
                ) : (
                  <BannerEmpty>Sem ícone de visualização</BannerEmpty>
                )}
              </Imagem>
              <FormGroup style={{ marginLeft: '20px' }}>
                <label>Formatos: PNG, JPG</label>
                <label>Dimensão recomendada: 192x192.</label>
                {showMessageErrorMaxSizeFileIcon && (
                  <ErrorMessage>
                    Arquivo excedeu o limite de 2MB.
                  </ErrorMessage>
                )}
                <div style={{ display: 'flex' }}>
                  <Upload
                    disabled={disabledFields}
                    label={content.channelData && content.channelData.icon ? 'ALTERAR' : 'ADICIONAR'}
                    onUpload={this.uploadFileIcon}
                    accept="image/png,image/jpg,image/jpeg"
                    maxSize={2000000}
                    onRejectMaxSize={() => {
                      this.setState({ showMessageErrorMaxSizeFileIcon: true });
                    }}
                    onClick={() => {
                      this.setState({ showMessageErrorMaxSizeFileIcon: false });
                    }}
                  />
                  {content.channelData && content.channelData.icon && (
                    <Button
                      disabled={disabledFields}
                      style={{ marginTop: '15px' }}
                      title="REMOVER"
                      onClick={() => {
                        this.handleSuccessIcon('');
                      }}
                    />
                  )}
                </div>
              </FormGroup>
            </Row>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <label>
              Imagem
            </label>
            <Row>
              <Imagem invalid={false /* hasError && this.getImageIsInvalid() */}>
                {content.channelData && content.channelData.image ? (
                  <Image
                    className="success-img"
                    src={content.channelData.image}
                    alt="imagem"
                  />
                ) : (
                  <BannerEmpty>Sem imagem de visualização</BannerEmpty>
                )}
              </Imagem>
              <FormGroup style={{ marginLeft: '20px' }}>
                <label>Formatos: PNG, JPG</label>
                <label>Dimensão recomendada: 1024x512.</label>
                {showMessageErrorMaxSizeFileImage && (
                  <ErrorMessage>
                    Arquivo excedeu o limite de 2MB.
                  </ErrorMessage>
                )}
                <div style={{ display: 'flex' }}>
                  <Upload
                    disabled={disabledFields}
                    label={content.channelData && content.channelData.image ? 'ALTERAR' : 'ADICIONAR'}
                    onUpload={this.uploadFileImage}
                    accept="image/png,image/jpg,image/jpeg"
                    maxSize={2000000}
                    onRejectMaxSize={() => {
                      this.setState({ showMessageErrorMaxSizeFileImage: true });
                    }}
                    onClick={() => {
                      this.setState({ showMessageErrorMaxSizeFileImage: false });
                    }}
                  />
                  {content.channelData && content.channelData.image && (
                    <Button
                      disabled={disabledFields}
                      style={{ marginTop: '15px' }}
                      title="REMOVER"
                      onClick={() => {
                        this.handleSuccessImage('');
                      }}
                    />
                  )}
                </div>
              </FormGroup>
            </Row>
          </FormGroup>
        </Row>
        <Row>
          <h3>Botões</h3>
        </Row>
        <Row>
          <FormGroup style={{ flex: 1, marginRight: 10 }}>
            <label>
              Texto
              -
              <small>
                {` ${
                  content.channelData && content.channelData.button_text_1
                    ? content.channelData.button_text_1.length : 0}/50 caracteres`}
              </small>
            </label>
            <Input
              disabled={disabledFields}
              maxLength={50}
              placeholder="Digite o texto do botão"
              onChange={(e) => {
                campaignEditCriativoRequestSuccess({
                  ...criativoEdit,
                  content: {
                    ...criativoEdit.content,
                    channelData: {
                      ...criativoEdit.content.channelData,
                      button_text_1: e.target.value,
                    },
                  },
                });
              }}
              value={content.channelData ? content.channelData.button_text_1 || '' : ''}
              invalid={false /* hasError && this.getButtonText1IsInvalid() */}
            />
          </FormGroup>
          <FormGroup style={{ flex: 1 }}>
            <label>
              Link
              -
              <small>
                {` ${
                  content.channelData && content.channelData.button_url_1
                    ? content.channelData.button_url_1.length : 0}/1000 caracteres`}
              </small>
            </label>
            <Input
              disabled={disabledFields}
              maxLength={1000}
              placeholder="Digite o endereço do site"
              onChange={(e) => {
                campaignEditCriativoRequestSuccess({
                  ...criativoEdit,
                  content: {
                    ...criativoEdit.content,
                    channelData: {
                      ...criativoEdit.content.channelData,
                      button_url_1: e.target.value,
                    },
                  },
                });
              }}
              value={content.channelData ? content.channelData.button_url_1 || '' : ''}
              invalid={false /* hasError && this.getButtonUrl1IsInvalid() */}
            />
          </FormGroup>
        </Row>
        <Row>
          <FormGroup style={{ flex: 1, marginRight: 10 }}>
            <label>
              Texto
              -
              <small>
                {` ${
                  content.channelData && content.channelData.button_text_2
                    ? content.channelData.button_text_2.length : 0}/50 caracteres`}
              </small>
            </label>
            <Input
              disabled={disabledFields}
              maxLength={50}
              placeholder="Digite o texto do botão"
              onChange={(e) => {
                campaignEditCriativoRequestSuccess({
                  ...criativoEdit,
                  content: {
                    ...criativoEdit.content,
                    channelData: {
                      ...criativoEdit.content.channelData,
                      button_text_2: e.target.value,
                    },
                  },
                });
              }}
              value={content.channelData ? content.channelData.button_text_2 || '' : ''}
              invalid={false /* hasError && this.getButtonText2IsInvalid() */}
            />
          </FormGroup>
          <FormGroup style={{ flex: 1 }}>
            <label>
              Link
              -
              <small>
                {` ${
                  content.channelData && content.channelData.button_url_2
                    ? content.channelData.button_url_2.length : 0}/1000 caracteres`}
              </small>
            </label>
            <Input
              disabled={disabledFields}
              maxLength={1000}
              placeholder="Digite o endereço do site"
              onChange={(e) => {
                campaignEditCriativoRequestSuccess({
                  ...criativoEdit,
                  content: {
                    ...criativoEdit.content,
                    channelData: {
                      ...criativoEdit.content.channelData,
                      button_url_2: e.target.value,
                    },
                  },
                });
              }}
              value={content.channelData ? content.channelData.button_url_2 || '' : ''}
              invalid={false /* hasError && this.getButtonUrl2IsInvalid() */}
            />
          </FormGroup>
        </Row>
        <LandingPage
          title="Configuração da Landing Page"
          campaign={campaign}
          criativoEdit={criativoEdit}
          campaignEditCriativoRequestSuccess={campaignEditCriativoRequestSuccess}
          hasError={hasError}
          disabledFields={disabledFields}
        />
      </>
    );
  }
}

SMSMediaMessageForm.propTypes = {
  campaign: PropTypes.shape().isRequired,
  criativoEdit: PropTypes.shape().isRequired,
  campaignEditCriativoRequestSuccess: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  startRequest: PropTypes.func.isRequired,
  requestSuccess: PropTypes.func.isRequired,
  requestError: PropTypes.func.isRequired,
  errorMessage: PropTypes.func.isRequired,
  disabledFields: PropTypes.bool.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    startRequest: requestLoading,
    requestSuccess: successLoading,
    requestError: errorLoading,
    errorMessage: ToastrMessageActions.errorMessage,
  },
  dispatch,
);

export default connect(
  null,
  mapDispatchToProps,
)(SMSMediaMessageForm);
